<div
    class="agpr-insightCard agpr-contextMenu-parent"
    [ngClass]="{ 'agpr-insightCard--disabled': generateDisabled || isAiGenerating }"
>
    <div
        [id]="id"
        role="button"
        class="agpr-insightCard-topRow"
        tabindex="0"
        [attr.aria-label]="(isEmpty ? 'Generate ' : 'Toggle ') + (label | localize)"
        [attr.aria-expanded]="expanded"
        (keydown.enter)="generateButtonClicked()"
        (keydown.space)="generateButtonClicked()"
        (click)="generateButtonClicked()"
    >
        <h4
            class="agpr-insightCard-name"
            [id]="id + '_insightName'"
        >
            @if (preLabelIcon) {
                <span
                    class="agpr-insightCard-insightIcon fa-kit-duotone fa-agpr-insights"
                ></span>
            }

            <div class="agpr-insightCard-labelContainer">
                <span class="agpr-insightCard-label">
                    {{ label | localize }}
                    @if (infoCircleTooltip) {
                        <span
                            class="fa-regular fa-circle-info agpr-insightCard-infoIcon"
                            role="img"
                            [agprTooltip]="infoCircleTooltip"
                            tooltipPosition="top"
                        ></span>
                    }
                </span>
            </div>

            <span
                [agprLoading]="isPromptGenerating"
                [loadingSmallIndicator]="isPromptGenerating"
                class="agpr-insightCard-insightIcon"
                [ngClass]="{
                    'fa-kit-duotone fa-agpr-insights': !isPromptGenerating && !preLabelIcon,
                    'agpr-insightCard-insightIcon-spinner': isPromptGenerating
                }"
            ></span>
        </h4>

        <span
            *ngIf="saved"
            role="img"
            class="agpr-insightCard-savedIcon fa-kit fa-agpr-check-save"
            [pTooltip]="'Mention.saved' | localize"
            tooltipPosition="top"
            [attr.aria-label]="'Mention.saved' | localize"
        ></span>

        <agpr-button
            *ngIf="isPromptGenerating"
            [id]="id + '_stopGenerationButton'"
            [style]="buttonTypes.tertiary"
            label="Mention.insightsExplorerTab.quickInsights.stop"
            (click)="stopButtonClicked()"
        ></agpr-button>
        <span
            *ngIf="!isPromptGenerating"
            class="agpr-insightCard-toggleIcon"
            [ngClass]="expanded ? 'fa-solid fa-angle-up' : 'fa-solid fa-angle-down'"
            aria-hidden="true"
        ></span>
    </div>
    <div
        #contentWrapper
        [ngClass]="{ 'agpr-insightCard-toggledContentWrapper--overflown': !expanded || animating }"
        [@panelContent]="expanded ? 'visible' : 'hidden'"
        (@panelContent.done)="onToggleDone()"
        [attr.aria-hidden]="!expanded"
        [attr.aria-labelledby]="ariaLabelledBy || id + '_insightName'"
    >
        <ng-content></ng-content>
    </div>

    <div class="agpr-contextMenu bottom right">
        @if (showEdit && expanded && !isPromptGenerating) {
            <agpr-button
                [style]="buttonTypes.contextMenu"
                icon="fa-regular fa-duotone fa-pen"
                tooltip="Mention.insightsExplorerTab.editPrompt"
                tooltipPosition="top"
                (click)="editPrompt()"
            ></agpr-button>
        }
        <agpr-button
            *ngIf="savable && expanded && !isPromptGenerating"
            [style]="buttonTypes.contextMenu"
            icon="fa-regular fa-duotone fa-floppy-disk"
            [disabled]="saved"
            tooltip="Mention.insightsExplorerTab.saveInsights"
            tooltipPosition="top"
            (click)="saveButtonClicked()"
        ></agpr-button>
    </div>
</div>
